import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';

// Use to compare two conditions.
// Conditions coming from CS don't have pricingId, so we need to compare them.
//
// Use with care!
//
// This function needs QA, it could be many edge / not predicted cases.
// However, right now it is only used to pre-select the conditions group in the UI, so a bad comparison would only have consequences in the UI.

export const areConditionsEqual = (a: LoanConditions | undefined, b: LoanConditions | undefined): boolean => {
  if (!a || !b) {
    return false;
  }

  const hasSameGracePercentage = (a: LoanConditions, b: LoanConditions): boolean => {
    if (!a.gracePercentage && !b.gracePercentage) {
      return true;
    }
    return a.gracePercentage === b.gracePercentage;
  };

  const hasSameGracePeriod = (a: LoanConditions, b: LoanConditions): boolean => {
    if (!a.gracePeriod && !b.gracePeriod) {
      return true;
    }
    return a.gracePeriod === b.gracePeriod;
  };

  const hasSameMerchantDiscountPercentage = (a: LoanConditions, b: LoanConditions): boolean => {
    if (!a.merchantDiscountPercentage?.value && !b.merchantDiscountPercentage?.value) {
      return true;
    }
    return a.merchantDiscountPercentage?.value === b.merchantDiscountPercentage?.value;
  };

  const hasSameSetupFee = (a: LoanConditions, b: LoanConditions): boolean => {
    if (!a.setupFee?.value && !b.setupFee?.value) {
      return true;
    }
    // TODO: Implement setupFee percentage vs. setupFee value comparison?
    return true;
  };

  return (
    a.annualInterest?.value === b.annualInterest?.value &&
    // a.apr?.value === b.apr?.value &&
    hasSameGracePercentage(a, b) &&
    hasSameGracePeriod(a, b) &&
    a.instalmentTotalAmount?.value === b.instalmentTotalAmount?.value &&
    hasSameMerchantDiscountPercentage(a, b) &&
    a.principal?.value === b.principal?.value &&
    a.providerName === b.providerName &&
    hasSameSetupFee(a, b) &&
    a.setupFeeType === b.setupFeeType &&
    a.term === b.term
    // a.totalAmount === b.totalAmount // Sometimes the calculations differ a bit by decimals ??
  );
};
